module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "contents",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('a', {
    attrs: {
      "href": "#/text/Chapter01#ach1"
    }
  }, [_vm._v("1.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter01#ach1"
    }
  }, [_vm._v("The “M” in STEM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('a', {
    attrs: {
      "href": "#/text/Chapter02#ach2"
    }
  }, [_vm._v("2.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter02#ach2"
    }
  }, [_vm._v("A Harsh and Senseless Hurdle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#ach3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter03#ach3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Will Plumbers Need Polynomials?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#ach4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter04#ach4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Does Your Dermatologist Use Calculus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#ach5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter05#ach5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gender Gaps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#ach6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter06#ach6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Does Mathematics Enhance Our Minds?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter07#ach7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter07#ach7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mandarins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter08#ach8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter08#ach8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Common Core: One Size for All")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter09#ach9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter09#ach9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discipline Versus Discovery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch10"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter10#ach10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter10#ach10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teaching, Tracking, Testing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch11"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter11#ach11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter11#ach11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Not to Treat Statistics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ch12"
    }
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/text/Chapter12#ach12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.")])]), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter12#ach12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Numeracy 101")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2t",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Acknowledgments#aack",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "notes"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Notes#anotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "index"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Index#aindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 72
// module chunks = 0